import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import GdsIssIndexActions, { GdsIssIndexTypes } from '../Stores/GdsIssIndex/Actions';

const getAppStore = state => state.app;

export function* gdsIssIndexFetchGdsIssIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(GdsIssIndexActions.gdsIssIndexFetchGdsIssIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `gdsIss/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        GdsIssIndexActions.gdsIssIndexFetchGdsIssIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsIssIndexActions.gdsIssIndexFetchGdsIssIndexLoading(false));
  }
}

export function* gdsIssIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/gdsIssDetail/update/${hdrId}`));
}

export function* gdsIssIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/GDS_ISS/${hdrId}/GdsIssHdr`));
}

export function* gdsIssIndexResetGdsIssFServ01({ hdrIds }) {
  try {
    yield put(GdsIssIndexActions.gdsIssIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `gdsIss/fServProcess/RESET_GDS_ISS_F_SERV_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(GdsIssIndexActions.gdsIssIndexResetGdsIssFServ01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsIssIndexActions.gdsIssIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(GdsIssIndexTypes.GDS_ISS_INDEX_GO_TO_DOCUMENT, gdsIssIndexGoToDocument),
  takeLatest(GdsIssIndexTypes.GDS_ISS_INDEX_GO_TO_AUDIT, gdsIssIndexGoToAudit),
  takeLatest(GdsIssIndexTypes.GDS_ISS_INDEX_FETCH_GDS_ISS_INDEX, gdsIssIndexFetchGdsIssIndex),
  takeLatest(GdsIssIndexTypes.GDS_ISS_INDEX_RESET_GDS_ISS_F_SERV01, gdsIssIndexResetGdsIssFServ01)
];
